import Vue from "vue";
import VueRouter from "vue-router";

if (process.env.NODE_ENV === "development") {
    Vue.use(VueRouter);
}

import { ROUTER_MODE } from "../config/app";

import Home from "../views/home/index.vue";

// Management group related
import adminRouter from "../views/userManage/admin/router.vue";
import authAdmin from "../views/userManage/admin/authAdmin.vue";
import authRole from "../views/userManage/admin/authRole.vue";
import authPermissionRule from "../views/userManage/admin/authPermissionRule.vue";
import brand from "../views/userManage/admin/brand.vue";


// epc
import epc from "../views/epc/epc.vue"
import cache from "../views/cache/cache.vue"


// Vue.use(VueRouter);

const err401 = r =>
    require.ensure([], () => r(require("../views/error/err401.vue")), "home");
const err404 = r =>
    require.ensure([], () => r(require("../views/error/err404.vue")), "home");
const login = r =>
    require.ensure([], () => r(require("../views/login/index.vue")), "home");
const main = r =>
    require.ensure([], () => r(require("../views/home/main.vue")), "home");

// Note the permission field authrule (strictly case sensitive)
export const constantRouterMap = [{
        path: "*",
        component: err404,
        hidden: true
    },
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err404,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "login",
        hidden: true
    },
    {
        path: "/",
        component: Home,
        redirect: "/readme",
        name: "Home",
        hidden: true
    },
    {
        path: "/readme",
        component: Home,
        redirect: "/readme/main",
        hidden: true,
        icon: "shouye",
        name: "Home",
        noDropdown: true,
        children: [{
            path: "main",
            component: main
        }]
    },
];

export default new VueRouter({
    // mode: 'history', //Back end support can be opened
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    strict: process.env.NODE_ENV !== "production"
});

export const asyncRouterMap = [{
        path: "/System",
        redirect: "/readme",
        component: Home,
        icon: "guanliyuan1",
        name: "System",
        meta: {
            authRule: ["user_manage"]
        },
        // noDropdown: true,
        // children: [{
        //     path: "/userManage/adminManage",
        //     component: adminRouter,
        //     redirect: "/userManage/authAdmin/index",
        //     name: "Administration",
        //     icon: "",
        //     meta: {
        //         authRule: ["user_manage/admin_manage"]
        //     },
        children: [{
                    path: "authAdmin",
                    component: authAdmin,
                    name: "User ",
                    icon: "",
                    meta: {
                        authRule: ["admin/auth/user/index"]
                    }
                },
                {
                    path: "authRole",
                    component: authRole,
                    name: "Role ",
                    icon: "",
                    meta: {
                        authRule: ["admin/auth/role/index"]
                    }
                },
                {
                    path: "authPermissionRule",
                    component: authPermissionRule,
                    name: "Permission ",
                    icon: "",
                    meta: {
                        authRule: ["admin/auth/permission_rule/index"]
                    }
                },
                {
                    path: "brand",
                    component: brand,
                    name: "Brand",
                    icon: "",
                    meta: {
                        authRule: ["brand/index"]
                    }
                }
            ]
            // }]
    },
    {
        path: "/epc",
        component: Home,
        redirect: "/epc/epc",
        icon: "tongyong",
        name: "EPC Data",
        noDropdown: true,
        children: [{
            path: "epc",
            component: epc
        }],
        meta: {
            authRule: ["epcData/index"]
        }
    },
    {
        path: "/cache",
        component: Home,
        redirect: "/cache/cache",
        icon: "tongyong",
        name: "Cache",
        noDropdown: true,
        children: [{
            path: "cache",
            component: cache
        }],
        meta: {
            authRule: ["cache/restore"]
        }
    }
]